import { RangePickerProps } from 'antd/lib/date-picker'
import dayjs from 'dayjs'

export const hideDatesAfterToday: RangePickerProps['disabledDate'] = (date) => {
  return date && date > dayjs().endOf('day')
}
